(function() {
    'use strict';

    angular.module('app').component('uiGlRoute', {
        templateUrl: 'js/components/ui-gl-route/index.html',
        controller: UiGlRouteController,
        controllerAs: '$ugr',
        bindings: {
            api: '<',
        },
    });

    UiGlRouteController.$inject = ['$scope', '$http', '$q', 'toaster', '$translate', '$timeout'];

    function UiGlRouteController($scope, $http, $q, toaster, $translate, $timeout) {
        var $ctrl = this;

        var api = {
            init: init,
            setOptions: setOptions,
            draw: draw,
            refresh: refresh,
            clear: clear,
            destroy: destroy,
            changeEventMode: changeEventMode,
            isMaxSpeedEventMode: isMaxSpeedEventMode,
        };

        var MARKER_LABEL_OPTIONS = {
            fontWeight: 'bold',
            fontSize: '10px',
            color: '#ddd',
        };

        /**
         * @TODO - WID-308 - VERIFY
         */

        function refresh() {
            var endpoint = '/api/node/object/last-location?objectId=' + options.object.id;

            return $http.get(endpoint).then(function(response) {
                var data = response.data.data[0];
                draw(false);

                return {
                    messageId: data.MessageId,
                    last: {
                        gpsTime: data.GpsTime,
                        x: data.X,
                        y: data.Y,
                        angle: data.VectorAngle,
                        speed: data.VectorSpeed,
                    },
                };
            });
        }

        function getMarkerIconRefilling() {
            return {
                path:
                    'M39.545,0H4.72C2.706,0,1.072,1.634,1.072,3.648v74.427h42.116V3.648   C43.188,1.634,41.562,0,39.545,0z M37.945,27.827H6.323V7.115h31.623V27.827z M59.926,79.536c-8.647,0-13.888-5.95-14.385-16.321   c-0.207-4.091,0.818-8.591,1.9-13.36c0.813-3.583,1.662-7.28,2.061-11.083c0.399-3.814-0.201-5.111-0.595-5.546   c-0.73-0.813-2.879-0.813-4.956-0.813h-1.022v-5.056h1.022c3.035,0,6.479,0,8.715,2.486c1.75,1.937,2.341,4.947,1.869,9.46   c-0.43,4.091-1.305,7.954-2.153,11.682c-1,4.417-1.952,8.596-1.792,11.982c0.367,7.643,3.511,11.512,9.336,11.512   c6.4,0,9.647-4.045,9.647-12.02c0-6.597-2.051-11.733-3.413-15.13l-0.533-1.367c-1.413-3.702-1.6-7.021-1.745-12.052   c-0.145-4.883-0.088-10.105,1.264-15.266c1.362-5.19,4.163-7.72,8.798-11.909l1.118-1.018l3.402,3.744l-1.134,1.023   c-4.334,3.922-6.312,5.711-7.291,9.447c-1.191,4.536-1.228,9.328-1.104,13.831c0.141,4.908,0.332,7.539,1.419,10.397l0.508,1.284   c1.419,3.531,3.77,9.435,3.77,17.005C74.627,73.151,69.128,79.536,59.926,79.536z M66.435,34.769l-0.129-5.059   c0,0,3.92-0.101,6.142-0.127c0.051-0.896,0.051-2.296,0.051-3.764v-0.754c0-6.05-0.947-6.851-2.034-7.785   c-0.399-0.334-0.793-0.684-1.176-1.103l3.718-3.418c0.238,0.259,0.497,0.466,0.74,0.673c2.16,1.843,3.807,3.866,3.807,11.627v0.753   c0,2.835,0.005,4.401-0.249,5.592c-0.435,2.048-1.843,3.226-3.862,3.226C71.8,34.631,66.441,34.769,66.435,34.769z',
                fillColor: '#3cb371',
                fillOpacity: 1,
                strokeWeight: 1,
                strokeColor: '#333',
                scale: 0.4,
                anchor: new google.maps.Point(25, 0),
                labelOrigin: new google.maps.Point(25, 50),
            };
        }

        var MARKER_TYPE_STOP = 'stop';
        var MARKER_TYPE_REFILLING = 'refilling';

        var MODE_MAX_SPEED = 1;
        var MODE_STATISTICS = 2;

        var mode = MODE_MAX_SPEED;

        var options = {
            object: null,
            start: null,
            end: null,
        };

        var map = {
            object: null,
            overlays: [],
        };

        var data = {
            route: [],
            stops: [],
            refillings: [],
        };

        var markers = {
            stops: {
                cluster: null,
                event: null,
            },
            refillings: {
                data: [],
                event: null,
            },
            event: null,
        };

        var uiFragmentManager = null;

        $ctrl.markers = [];

        var settings = null;

        function destroy() {
            $ctrl.uiGwStopApi.fn.close(false);
            clear();
        }

        function changeEventMode() {
            uiFragmentManager.reset();
            uiFragmentManager.clear();
            mode = mode === MODE_STATISTICS ? MODE_MAX_SPEED : MODE_STATISTICS;
        }

        function isMaxSpeedEventMode() {
            return mode === MODE_MAX_SPEED;
        }

        function clear() {
            for (var i = 0; i < map.overlays.length; i++) {
                map.overlays[i].setMap(null);
            }
            map.overlays = [];
            $ctrl.markers = [];

            markers.refillings.data.map(function(o) {
                o.setMap(null);
            });

            markers.stops.cluster = null;
            markers.refillings.data = [];

            uiFragmentManager.clear();

            return true;
        }

        function googlePolylineClickEvent(event, polyline, points) {
            if (!mode) {
                return;
            }

            var latlng = event.latLng;
            var needle = {
                minDistance: 9999999999,
                index: -1,
                latlng: null,
            };

            polyline.getPath().forEach(function(point, index) {
                var dist = google.maps.geometry.spherical.computeDistanceBetween(latlng, point);
                if (dist < needle.minDistance) {
                    needle.minDistance = dist;
                    needle.index = index;
                    needle.latlng = point;
                }
            });

            if (points[needle.index] === void 0) {
                return;
            }

            switch (mode) {
                case MODE_MAX_SPEED:
                    var now = moment.utc();
                    var isTodayPoint = now.isSame(points[needle.index].date, 'day');

                    toaster.clear();
                    toaster.pop(
                        'info',
                        points[needle.index].date.format(isTodayPoint ? 'HH:mm:ss' : 'YYYY-MM-DD HH:mm:ss'),
                        $translate.instant('routes.messages.speed') + ' - ' + points[needle.index].speed + ' km/h'
                    );
                    $scope.$apply();

                    break;
                case MODE_STATISTICS:
                    var start = uiFragmentManager.start;
                    var end = uiFragmentManager.end;

                    if (start && end) {
                        start = false;
                        end = false;
                    }

                    if (!start) {
                        uiFragmentManager.clear();
                        start = needle.index;
                    } else {
                        end = needle.index;
                    }

                    uiFragmentManager.drawPoint(start);

                    if (start && end && start > end) {
                        var tmp = start;
                        start = end;
                        end = tmp;
                    }

                    uiFragmentManager.start = start;
                    uiFragmentManager.end = end;

                    if (start && end) {
                        uiFragmentManager.draw();
                        uiFragmentManager.drawPoint(start);
                        uiFragmentManager.drawPoint(end);
                    }
                    break;
            }
        }

        function getSettings(settings) {
            var speed = (((settings || {}).notifications || {}).speed || {}).value;
            if (speed !== void 0) {
                speed = Number(speed);
            }

            var refuellings = (((settings || {}).fuel || {}).tanks || {}).objects;
            refuellings = typeof refuellings === 'string' ? refuellings : '';
            refuellings = refuellings
                .split(',')
                .filter(function(o) {
                    return o;
                })
                .map(function(o) {
                    return Number(o);
                });

            return {
                maxAllowedSpeed: speed,
                refuellingDisabledObjects: refuellings,
            };
        }

        function setOptions(opts) {
            options = opts;
            $ctrl.uiGwStopApi.fn.setObject(options.object);
        }

        function init(m, s) {
            map.object = m;
            settings = getSettings(s);

            uiFragmentManager = new UiFragmentManager(map.object, s, {
                $http: $http,
                $translate: $translate,
                toaster: toaster,
            });
        }

        function getStopModel(o) {
            return {
                messageId: o.messageId,
                lat: o.posY,
                lng: o.posX,
                start: o.start,
                end: o.end,
            };
        }

        function getRefillingModel(o) {
            return {
                messageId: o.FuelTanks.Before.MessageId,
                lat: o.FuelTanks.Before.Y,
                lng: o.FuelTanks.Before.X,
                start: o.FuelTanks.Before.GpsTime,
                end: o.FuelTanks.After.GpsTime,
                fuel: {
                    before: o.FuelTanks.Before.Value,
                    after: o.FuelTanks.After.Value,
                },
            };
        }

        function getObjectRefillings() {
            if (settings.refuellingDisabledObjects.indexOf(options.object.id) >= 0) {
                return $q.resolve([]);
            }

            var endpoint =
                '/api/node/object/fuel-tank?source=auto&object=' +
                options.object.id +
                '&start=' +
                options.start +
                '&end=' +
                options.end;
            return $http.get(endpoint).then(function(response) {
                var data = response.data.data;
                return data.tanks;
            });
        }

        function getObjectRoute() {
            var endpoint = `/api/object/${options.object.id}/routeSimple`;

            return $http
                .get(endpoint, {
                    params: {
                        start: options.start,
                        end: options.end,
                    },
                })
                .then(function(response) {
                    return response.data.data;
                });
        }

        function createMarker(o, i, type) {
            var position = new google.maps.LatLng(o.lat, o.lng);

            var label = MARKER_LABEL_OPTIONS;
            label.text = String(i + 1);

            var data = {
                id: i,
                model: o,
                type: type,
            };

            var opts = {
                position: position,
                label: label,
                data: data,
            };

            if (type === MARKER_TYPE_REFILLING) {
                opts.icon = getMarkerIconRefilling();
            }

            var marker = new google.maps.Marker(opts);
            marker.addListener('click', markerClickEventListener);

            return marker;
        }

        function recalculateMapCenterPosition(lat, lng, zoom) {
            var y = 0;
            if ($ctrl.uiGwStopApi.data.show) {
                var mapHeight = angular.element('.angular-google-map').height();
                var owHeight = angular.element('.box-object-information-window').height();

                if (!isNaN(mapHeight) && !isNaN(owHeight)) {
                    y = -Math.round(owHeight / 2);
                }
            }
            return offsetPoint(lat, lng, 0, y, zoom);
        }

        var latLngToPoint = function(lat, lng) {
            var latLng = new google.maps.LatLng(lat, lng);
            return map.object.getProjection().fromLatLngToPoint(latLng);
        };

        var offsetPoint = function(lat, lng, offsetX, offsetY, zoom) {
            if (zoom === false || typeof zoom === 'undefined') {
                zoom = map.object.zoom;
            }
            var scale = Math.pow(2, zoom);
            var worldCoordinateCenter = latLngToPoint(lat, lng);
            var pixelOffset = new google.maps.Point(offsetX / scale || 0, offsetY / scale || 0);
            var worldCoordinateNewCenter = new google.maps.Point(
                worldCoordinateCenter.x - pixelOffset.x,
                worldCoordinateCenter.y + pixelOffset.y
            );
            return map.object.getProjection().fromPointToLatLng(worldCoordinateNewCenter);
        };

        function initUiGwStopApi() {
            var onCoordsChange = function(coords) {};
            var onResize = function() {
                $timeout(function() {
                    var position = angular.copy($ctrl.uiGwStopApi.data.coords);
                    var zoom = map.object.zoom;

                    var point = recalculateMapCenterPosition(position.latitude, position.longitude, zoom);
                    map.object.panTo(point);
                }, 100);
            };

            var uiGwStopEvents = {
                coordsChange: onCoordsChange,
                resize: onResize,
            };
            $ctrl.uiGwStopApi = new UiGwStopObject(uiGwStopEvents);
        }

        initUiGwStopApi();

        function markerClickEventListener(gm, gl, o) {
            var position = o !== void 0 ? new google.maps.LatLng(o.latitude, o.longitude) : this.position;
            var data = o !== void 0 ? o.data : this.data;

            if (typeof markers.event === 'function') {
                markers.event(this);
            }

            $ctrl.uiGwStopApi.fn.setCoords(position);
            $ctrl.uiGwStopApi.fn.setStopData(data);
            $ctrl.uiGwStopApi.fn.open();

            $scope.$apply();
        }

        $ctrl.stopClick = function(gm, en, marker) {
            markerClickEventListener(null, null, marker);
        };

        function drawMarkers() {
            $ctrl.markers = data.stops.map(function(o, i) {
                var model = getStopModel(o);
                var marker = {
                    id: Number(i + 1),
                    messageId: model.messageId,
                    type: 'stop',
                    latitude: model.lat,
                    longitude: model.lng,
                    markerOptions: {
                        label: {
                            text: 'P' + String(i + 1),
                            fontWeight: 'bold',
                            fontSize: '9px',
                            color: '#fff',
                        },
                    },
                    data: {
                        id: i,
                        model: model,
                        type: 'stop',
                    },
                };
                return marker;
            });

            markers.refillings.data = data.refillings.map(function(o, i) {
                var model = getRefillingModel(o);
                var marker = createMarker(model, i, 'refilling');

                marker.setMap(map.object);
                return marker;
            });

            return true;
        }

        function draw(fit) {
            clear();

            return $q.all([getObjectRoute(), getObjectRefillings()]).then(function(response) {
                var routes = response[0];
                if (routes.route.length == 0 && routes.stops.length == 0) {
                    toaster.pop({
                        type: 'info',
                        title: $translate.instant('routes.messages.noDatas.title'),
                        body: $translate.instant('routes.messages.noDatas.body'),
                        timeout: 10000,
                        bodyOutputType: 'trustedHtml',
                    });
                    return;
                }

                data.route = routes.route;
                data.stops = routes.stops;
                data.refillings = response[1];

                var points = routes.route.map(function(o) {
                    return {
                        lat: o.Y,
                        lng: o.X,
                        speed: o.VectorSpeed,
                        date: moment.utc(o.GpsTime),
                    };
                });

                uiFragmentManager.set({ id: options.object.id, points: points });

                for (var i = 0; i < points.length - 1; i++) {
                    var stroke =
                        settings.maxAllowedSpeed && points[i].speed > settings.maxAllowedSpeed
                            ? { color: '#FF0000', weight: 2 }
                            : { color: '#0000FF', weight: 2 };

                    var pathFragment = new google.maps.Polyline({
                        path: [points[i], points[i + 1]],
                        geodesic: true,
                        clickable: false,
                        strokeColor: stroke.color,
                        strokeOpacity: 1.0,
                        strokeWeight: stroke.weight,
                        map: map.object,
                    });
                    map.overlays.push(pathFragment);
                }

                var pathDirections = new google.maps.Polyline({
                    path: points,
                    geodesic: true,
                    strokeOpacity: 0.0,
                    strokeWeight: 30,
                    icons: [
                        {
                            icon: {
                                path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                                scale: 4,
                                strokeColor: '#0000FF',
                                strokeOpacity: 1,
                                strokeWeight: 2,
                                fillColor: '#0000FF',
                                fillOpacity: 1,
                            },
                        },
                    ],
                });

                google.maps.event.addListener(pathDirections, 'click', function(e) {
                    googlePolylineClickEvent(e, this, points);
                });

                map.overlays.push(pathDirections);
                pathDirections.setMap(map.object);

                var bound = new google.maps.LatLngBounds();
                for (var i = 0; i < routes.route.length; i++) {
                    var o = routes.route[i];
                    bound.extend({ lat: o.Y, lng: o.X });
                }

                if (fit === void 0 || fit) {
                    $timeout(function() {
                        map.object.fitBounds(bound);
                    }, 100);
                }

                drawMarkers();

                return data;
            });
        }

        $ctrl.$onInit = function() {
            angular.extend($ctrl.api, api);
            $ctrl.api.ready = true;
        };
    }

    function UiGwStopObject(events) {
        var data = {
            show: false,
            coords: null,
            options: {
                boxClass: 'box-object-market-window box-object-information-window',
                zIndex: 2,
                disableAutoPan: true,
            },
            object: null,
            stop: null,
        };

        function setObject(o) {
            data.object = o;
        }

        function setStopData(o) {
            data.stop = o;
        }

        function setCoords(o) {
            data.coords = {
                latitude: o.lat(),
                longitude: o.lng(),
            };
            return true;
        }

        function open() {
            data.show = true;
        }

        function close(resize) {
            data.show = false;

            resize = resize === void 0 || resize;
            resize && api.on.resize();
        }

        var api = {
            data: data,
            fn: {
                setCoords: setCoords,
                setStopData: setStopData,
                setObject: setObject,
                open: open,
                close: close,
            },
            on: events,
        };

        return api;
    }

    function UiFragmentManager(map, settings, injects) {
        var self = this;

        self.map = map;
        self.overlays = [];

        self.injects = injects;

        self.settings = {
            distanceSource: (settings || {}).distanceSource !== void 0 ? settings.distanceSource : 'auto',
        };

        self.data = {
            id: null,
            points: [],
        };

        self.start = false;
        self.end = false;

        self.initial = angular.copy(self.data);
    }

    UiFragmentManager.prototype.reset = function() {
        self.start = false;
        self.end = false;
    };

    UiFragmentManager.prototype.set = function(data) {
        this.data = angular.extend(this.data, data);
    };

    UiFragmentManager.prototype.getStatistics = function() {
        var self = this;
        var endpoint = '/api/node/object/calculateDistance';

        var params = {
            id: self.data.id,
            start: self.data.points[self.start].date.format('YYYY-MM-DD HH:mm:ss'),
            end: self.data.points[self.end].date.format('YYYY-MM-DD HH:mm:ss'),
            type: self.settings.distanceSource,
        };

        return self.injects.$http.get(endpoint, { params: params }).then(function(response) {
            var distance = response.data.data.distance;
            return {
                distance: typeof distance === void 0 ? 0.0 : distance,
            };
        });
    };

    UiFragmentManager.prototype.drawPoint = function(index) {
        var self = this;
        var point = self.data.points[index];
        var center = { lat: point.lat, lng: point.lng };

        var circle = new google.maps.Marker({
            map: self.map,
            position: center,
            title: 'circle',
            icon: {
                strokeColor: '#3a3f51',
                strokeOpacity: 1.0,
                strokeWeight: 2,
                fillColor: '#3a3f51',
                fillOpacity: 1.0,
                path: google.maps.SymbolPath.CIRCLE,
                scale: 5,
                anchor: new google.maps.Point(0, 0),
            },
        });
        self.overlays.push(circle);
    };

    UiFragmentManager.prototype.clear = function() {
        var self = this;
        for (var i = 0; i < self.overlays.length; i++) {
            self.overlays[i].setMap(null);
        }
        self.overlays.splice(0, self.overlays.length);
    };

    UiFragmentManager.prototype.draw = function() {
        var self = this;

        var points = self.data.points;
        self.clear();

        var maxSpeed = 0;

        for (var i = 0; i < points.length - 1; i++) {
            if (i < self.start || i > self.end - 1) {
                continue;
            }

            maxSpeed = points[i].speed > maxSpeed ? points[i].speed : maxSpeed;

            var pl = new google.maps.Polyline({
                path: [points[i], points[i + 1]],
                geodesic: false,
                clickable: false,
                strokeColor: '#3a3f51',
                strokeOpacity: 0.8,
                strokeWeight: 5,
                zIndex: 2,
                map: self.map,
            });
            self.overlays.push(pl);
        }

        self.getStatistics().then(
            function(data) {
                var distance = Math.round(data.distance * 100) / 100;
                self.injects.toaster.pop(
                    'info',
                    self.injects.$translate.instant('routes.messages.fragment.speed') + ' - ' + maxSpeed + ' km/h',
                    self.injects.$translate.instant('routes.messages.fragment.distance') + ' - ' + distance + ' km'
                );
            },
            function() {
                self.injects.toaster.pop(
                    'error',
                    self.injects.$translate.instant('general.toastr.error.header'),
                    self.injects.$translate.instant('routes.messages.fragment.toastr')
                );
            }
        );
    };
})();
